var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                isCountry: false,
                adChannel: false,
                adPlacement: false
              }
            },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectNewDeviceOrAccount")
                  },
                  model: {
                    value: _vm.paramsData.dimension_kind,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "dimension_kind", $$v)
                    },
                    expression: "paramsData.dimension_kind"
                  }
                },
                _vm._l(_vm.deviceList, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.rawData.game_mark.indexOf("yjfm") == -1
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.getServer },
                        model: {
                          value: _vm.paramsData.is_prod,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "is_prod", $$v)
                          },
                          expression: "paramsData.is_prod"
                        }
                      },
                      _vm._l(_vm.severlist, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("pleaseSelectServer")
                        },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      _vm._l(_vm.serverList, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.envIdChange },
                        model: {
                          value: _vm.paramsData.env_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "env_id", $$v)
                          },
                          expression: "paramsData.env_id"
                        }
                      },
                      _vm._l(_vm.szgmEnv, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("serverChannel")
                        },
                        on: { change: _vm.serverChange },
                        model: {
                          value: _vm.server_channel,
                          callback: function($$v) {
                            _vm.server_channel = $$v
                          },
                          expression: "server_channel"
                        }
                      },
                      _vm._l(_vm.serverChannel, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("showTestServer")
                        },
                        on: { change: _vm.serverChannelChange },
                        model: {
                          value: _vm.show_test,
                          callback: function($$v) {
                            _vm.show_test = $$v
                          },
                          expression: "show_test"
                        }
                      },
                      _vm._l(_vm.serverType, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: _vm.$t("server")
                        },
                        on: { change: _vm.severChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: _vm.$t("customLevel")
                  },
                  on: { change: _vm.levelChange },
                  model: {
                    value: _vm.levelItem,
                    callback: function($$v) {
                      _vm.levelItem = $$v
                    },
                    expression: "levelItem"
                  }
                },
                _vm._l(_vm.customLevel, function(item) {
                  return _c("el-option", {
                    key: item.lable,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.levelItem == "1"
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: _vm.$t("pleaseInputLevel")
                    },
                    model: {
                      value: _vm.paramsData.recharge_levels,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "recharge_levels", $$v)
                      },
                      expression: "paramsData.recharge_levels"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: _vm.$t("characterLabel")
                  },
                  model: {
                    value: _vm.paramsData.character_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "character_id", $$v)
                    },
                    expression: "paramsData.character_id"
                  }
                },
                _vm._l(_vm.characterList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.tableData.length },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut ", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: { click: _vm.searchClick }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "sticky-table-header",
                  rawName: "v-sticky-table-header",
                  value: 0,
                  expression: "0"
                },
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              ref: "tableRef",
              attrs: { id: "tableRef", data: _vm.tableData, border: "" }
            },
            _vm._l(_vm.tableList, function(item, index) {
              return _c("el-table-column", {
                key: index,
                attrs: {
                  label: item.label,
                  prop: item.prop,
                  fixed: index == 0,
                  "min-width": 130,
                  "render-header": function(h, obj) {
                    return _vm.renderheader(h, obj, item.desc)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [_vm._v(" " + _vm._s(row[item.prop]) + " ")]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }